
import { MouseEventHandler } from 'react';
import { fontSizes, fonts } from '../../style/theme';
import { scale } from '../../util/scale';

export const unstyledButton = scale({
  fontFamily: fonts.Sans,
  fontSize: fontSizes.paragraph,
  backgroundColor: 'transparent',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  display: 'inline',
  marginLeft: '5px',
  padding: 0,
  textDecoration: 'underline',
  transition: '0.3s ease-in-out',
  width: 'fit-content',
  color: 'var(--text-primary)',
  fontWeight: '600',
  '&:hover': {
    color: 'black',
  },
});

export default function TextButton({
  onClick,
  children,
  className,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: string;
  className?: string;
}) {
  return (
    <button
      css={unstyledButton}
      className={className}
      onClick={(e) => onClick(e)}
      type="button"
    >
      {children}
    </button>
  );
}
